import { AutoMap } from "@automapper/classes"
import { Prelevement } from "../prelevement"
import { EMarqueCompteur } from "./enums/marque-compteur"
import { EMarqueMultimetre } from "./enums/marque-multimetre"
import { EModeleCompteur } from "./enums/modele-compteur"
import { EModeleMultimetre } from "./enums/modele-multimetre"
import { ETypeAppareil } from "./enums/type-appareil"
import { BaseDOM } from "../base.dom"
import { EMarqueAppareilAir } from "./enums/marque-appareil-air"
import { EModeleAppareilAir } from "./enums/modele-appareil-air"
import { EMarqueAppareilSurface } from "./enums/marque-appareil-surface"
import { EModeleAppareilSurface } from "./enums/modele-appareil-surface"

export class Appareil extends BaseDOM<Appareil> {
    /** No Code from the server */
    @AutoMap()
    Id?: number
    @AutoMap()
    Code: string = ''
    @AutoMap()
    Type: ETypeAppareil = ETypeAppareil.Compteur
    @AutoMap()
    Marque?: EMarqueCompteur | EMarqueMultimetre | EMarqueAppareilAir | EMarqueAppareilSurface
    @AutoMap()
    Modele?: EModeleCompteur | EModeleMultimetre | EModeleAppareilAir | EModeleAppareilSurface
    @AutoMap()
    NumeroInterne: string = ''

}